import { render } from "./HeaderSearch.vue?vue&type=template&id=f2bf0422"
import script from "./HeaderSearch.vue?vue&type=script&lang=js"
export * from "./HeaderSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"webpack-assets/vue/templates/common/header/parts/HeaderSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f2bf0422"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f2bf0422', __exports__)) {
    api.reload('f2bf0422', __exports__)
  }
  
  module.hot.accept("./HeaderSearch.vue?vue&type=template&id=f2bf0422", () => {
    api.rerender('f2bf0422', render)
  })

}


export default __exports__